import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  isUpdateLeaveMaternityOrder: boolean;
  timeListConfig: {
    month: number | null;
    year: number | null;
    employeeCode?: string;
  };
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  isUpdateLeaveMaternityOrder: false,

  timeListConfig: {
    month: null,
    year: null,
    employeeCode: "",
  },
};

const updateLeaveMaternityOrderSlice = createSlice({
  name: "updateLeaveMaternityOrder",
  initialState,
  reducers: {
    updateTimeListConfig: (state, action) => {
      Object.assign(state.timeListConfig, action.payload);
    },
    setIsUpdateLeaveMaternityOrder: (state, action) => {
      state.isUpdateLeaveMaternityOrder = action.payload;
    },
    updateLeaveMaternityOrderStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    updateLeaveMaternityOrderSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    updateLeaveMaternityOrderFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetFormUpdateLeaveMaternity: () => ({ ...initialState }),
  },
});

export const {
  updateTimeListConfig,
  setIsUpdateLeaveMaternityOrder,
  updateLeaveMaternityOrderStart,
  updateLeaveMaternityOrderSuccess,
  updateLeaveMaternityOrderFailed,
  resetFormUpdateLeaveMaternity,
} = updateLeaveMaternityOrderSlice.actions;

export default updateLeaveMaternityOrderSlice.reducer;
